import AdminLayout from "../../components/admin/layout/AdminLayout";
import SettingPage from "../../components/admin/setting/SettingPage";

function Setting() {
  return (
    <AdminLayout>
      <SettingPage />
    </AdminLayout>
  );
}

export default Setting;
